import is from 'is_js';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { ContentEditable, selectElementContents } from 'omni-common-ui';
import classnames from 'classnames';
import styles from './style.postcss';

const KEY_MATCH_REGEX = /^[0-9]$/;

class UnlockManualInput extends PureComponent {
  constructor() {
    super();
    this._onMouseDown = this._onMouseDown.bind(this);
    this._onTouchOrClick = this._onTouchOrClick.bind(this);
    this._onFocus = this._onFocus.bind(this);
    this._onKeyDown = this._onKeyDown.bind(this);
    this._onBlur = this._onBlur.bind(this);
    this._selectTheWholeText = this._selectTheWholeText.bind(this);
  }

  _onMouseDown(ev) {
    ev.preventDefault();
  }

  _onTouchOrClick(ev) {
    ev.preventDefault();
    const { htmlEl } = this.contentEditableComp;
    htmlEl && htmlEl.focus();
  }

  _onFocus() {
    this._selectTheWholeText();
  }

  _onBlur() {
    const { manualLessonSequence, max, min } = this.props;
    if (is.number(manualLessonSequence) &&
        (manualLessonSequence > min) &&
        (manualLessonSequence <= max)) return;
    this.props.onChange('');
  }

  _onKeyDown(ev) {
    const { manualLessonSequence, max } = this.props;

    if (ev.key === 'Backspace') return true;
    if (! ev.key.match(KEY_MATCH_REGEX)) {
      ev.preventDefault();
      return;
    }

    const selection = window.getSelection().toString();
    let newManualUnlockLessonSequence = manualLessonSequence;
    if ((is.string(newManualUnlockLessonSequence) || is.number(newManualUnlockLessonSequence)) &&
        selection !== newManualUnlockLessonSequence.toString()) {
      newManualUnlockLessonSequence = `${manualLessonSequence}${ev.key}`;
    } else {
      newManualUnlockLessonSequence = ev.key;
    }

    if (newManualUnlockLessonSequence.startsWith('0')) {
      ev.preventDefault();
      return;
    }
    newManualUnlockLessonSequence = Number.parseInt(newManualUnlockLessonSequence, 10);
    if (newManualUnlockLessonSequence > max ||
      newManualUnlockLessonSequence === 0 || ! ev.key.match(KEY_MATCH_REGEX)) {
      ev.preventDefault();
    }
  }

  _selectTheWholeText() {
    selectElementContents(this.contentEditableComp.htmlEl);
  }

  _isDisable() {
    const { min, max, disabled } = this.props;

    if (disabled) {
      return true;
    }
    if (! is.number(max)) {
      return true;
    }
    if (is.number(min) && max - min < 1) {
      return true;
    }
    return false;
  }

  render() {
    const { manualLessonSequence, onChange } = this.props;
    const unlockManualInputStyles = classnames(styles.UnlockManualInput, {
      [styles.__disable]: this._isDisable(),
    });
    return <div className={unlockManualInputStyles}
        ref={(ref) => { this.outerNode = ref; }}
        onMouseDown={this._onMouseDown}
        onClick={this._onTouchOrClick}
        onTouchStart={this._onTouchOrClick}>
      <ContentEditable className={styles.UnlockManualInput_manualUnlockLessonSequence}
          ref={(ref) => { this.contentEditableComp = ref; }}
          html={is.number(manualLessonSequence) ? manualLessonSequence.toString() : ''}
          disabled={this._isDisable()}
          onFocus={this._onFocus}
          onChange={onChange}
          onKeyDown={this._onKeyDown}
          onMouseDown={this._onMouseDown}
          onBlur={this._onBlur}
          onClick={this._selectTheWholeText}
          onTouchStart={this._selectTheWholeText} />
    </div>;
  }
}

UnlockManualInput.propTypes = {
  disabled: PropTypes.bool,
  className: PropTypes.string,
  min: PropTypes.number,
  max: PropTypes.number.isRequired,
  manualLessonSequence: PropTypes.string,
  onChange: PropTypes.func,
};

export default UnlockManualInput;



// WEBPACK FOOTER //
// ./containers/Group/AssignHomework/UnlockHomework/UnlockManualInput/index.jsx